import { useMemo } from 'react';
import type { SurveySectionKey, WizardStep } from '@hotjar/feedback/domain/common/Wizard/Wizard';
import { SectionStatus } from '@hotjar/feedback/domain/common/Wizard/Wizard';
import { wizardSections } from '@hotjar/feedback/domain/Surveys/Wizard/Wizard';

export type ContentlessWizardStep = Omit<
  WizardStep<SurveySectionKey>,
  'title' | 'mainContent' | 'summary' | 'sideContent'
>;

const getStepStatus = (isSectionValid: boolean) => {
  if (isSectionValid === true) return SectionStatus.SUCCESS;
  if (isSectionValid === false) return SectionStatus.ERROR;
  return undefined;
};

export const useWizardSteps = (
  wizardProps: {
    hiddenSections: Partial<Record<SurveySectionKey, boolean>>;
    openedSections: Partial<Record<SurveySectionKey, boolean>>;
    onToggleSection: (sectionName: SurveySectionKey) => void;
    activeSection: SurveySectionKey;
  },
  validationProps: Record<SurveySectionKey, boolean>,
): ContentlessWizardStep[] => {
  return useMemo(
    () =>
      wizardSections
        .filter((key) => wizardProps.hiddenSections[key] !== true)
        .map((key, index, allSections) => {
          const nextSection: SurveySectionKey = allSections[index + 1] ?? 'review';
          const successStatus = getStepStatus(validationProps[key]);

          return {
            isDone: wizardProps.openedSections[nextSection] ?? false,
            onDone: () => wizardProps.onToggleSection(key),
            onNext: () => wizardProps.onToggleSection(nextSection),
            key,
            status: wizardProps.activeSection === key ? undefined : successStatus,
          };
        }),
    [wizardProps, validationProps],
  );
};
